
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 159.51 156.88"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"CRS_In_Progress","data-name":"CRS In Progress"}},[_c('g',{attrs:{"id":"Stage_-_In_Progress","data-name":"Stage - In Progress"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M93.41 28.57h27.69c3.6 0 6.06.69 7.31 2s1.92 3.89 1.92 7.51v26.16H144V33.88a18.7 18.7 0 00-5.39-13.67 18.33 18.33 0 00-13.53-5.44H93.41V0l-20.3 23.16 20.3 20.3zM136.35 64.25L116 84.55h15v34.55c0 3.66-.7 6.15-2.08 7.41s-3.94 1.93-7.56 1.93H85.84v13.7h39.88a18.44 18.44 0 0019-19V84.55h14.77z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M64.22 128.44H37.67c-3.6 0-6.08-.69-7.37-2s-2-3.88-2-7.49V83h-7.13l22.49-20.3H28.34V39.31c0-3.65.71-6.15 2.12-7.4s4-1.93 7.71-1.93H72.6V16.27H33.85a18.85 18.85 0 00-13.72 5.39 18.34 18.34 0 00-5.5 13.63V62.7H0L21 83h-6.37v40.11A18.7 18.7 0 0020 136.8a18.45 18.45 0 0013.63 5.44h30.59v14.64l20.31-21.07-20.31-22.4z"}})])])])])
          )
        }
      }
    